<template>
  <div class="container mx-auto p-4 text-justify">
    <h2 class="text-2xl font-bold">Regolamento Generale sulla Protezione dei Dati</h2>
    <h4 class="text-xs text-gray-600">
      Regolamento (UE) 2016/679 del Parlamento Europeo e del Consiglio del 27 aprile 2016
    </h4>
    <div class="mt-4 pt-2 border-t-2 border-solid border-i4m-orange space-x">
      <p>
        <span class="font-bold">
          Informativa in materia di raccolta dei dati personali ai sensi degli artt. 13 e 14 del
          Regolamento (UE) 2016/679 (GDPR)
        </span>
      </p>
      <p class="mt-3">
        Ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (GDPR) con riferimento ai dati
        personali che si intendono fare oggetto di trattamento, si forniscono le seguenti
        informazioni:
      </p>
      <ol class="mx-auto px-4 mt-1 list-decimal">
        <li class="pt-2">
          <span class="font-bold">Finalità dei trattamenti.</span>
          I trattamenti a cui saranno sottoposti i dati personali, che saranno acquisiti e
          periodicamente aggiornati, hanno le finalità rispondenti all’espletamento dei servizi
          richiesti a 4T Insurtech S.r.l., specificamente descritti:
          <ul>
            <li>a. Stipula di polizze assicurative;</li>
            <li>b. Campagne marketing;</li>
          </ul>
        </li>
        <li class="pt-2">
          <span class="font-bold">Natura del conferimento.</span>
          Il conferimento dei dati personali è necessario per costituire i rapporti contrattuali
          citati al precedente punto 1) e l’eventuale rifiuto di fornire tali dati comporterebbe
          l’impossibilità di gestire detti rapporti, con la conseguente impossibilità della
          costituzione dei rapporti medesimi, siano questi contratti assicurativi, altri contratti,
          autorizzazioni, di competenza di 4T Insurtech S.r.l.;
        </li>
        <li class="pt-2">
          <span class="font-bold">Modalità di trattamento e conservazione.</span>
          Il trattamento sarà svolto in forma automatizzata e/o manuale, con modalità e strumenti,
          nel rispetto delle misure di sicurezza di cui all’art. 32 del GDPR 2016/679, ad opera di
          soggetti appositamente incaricati, in ottemperanza a quanto previsto dagli art. 29 GDPR
          2016/679. Si segnala che, nel rispetto dei principi di liceità, limitazione delle finalità
          e minimizzazione dei dati, ai sensi dell’art. 5 GDPR 2016/679, il periodo di conservazione
          dei dati personali è stabilito per un arco di tempo non superiore al conseguimento delle
          finalità per le quali sono raccolti e trattati e nel rispetto delle tempistiche prescritte
          dalla Legge;
        </li>
        <li class="pt-2">
          <span class="font-bold">Ambito di applicazione dei dati.</span>
          I dati non saranno comunicati a terzi, ad esclusione di:
          <ul>
            <li>
              a. Compagnie assicurative, per la finalità di: stipula della polizza assicurativa;
            </li>
            <li>
              b. Società di marketing, per le finalità di: campagne marketing e conseguente raccolta
              dei dati personali generali;
            </li>
            <li>c. Studio Commercialista, per le finalità di: adempimenti fiscali e tributari;</li>
          </ul>
        </li>
        <li class="pt-2">
          <span class="font-bold">Soggetti che potranno venire a conoscenza dei dati.</span>
          Potranno venire a conoscenza dei dati il Responsabile del Trattamento, gli Incaricati del
          Trattamento nonché gli incaricati alla manutenzione degli elaboratori elettronici e del
          software gestionale in dotazione a 4T Insurtech S.r.l.;
        </li>
        <li class="pt-2">
          <span class="font-bold">Titolare del Trattamento e Responsabili del trattamento.</span>
          Titolare del Trattamento è 4T Insurtech S.r.l., con sede in Via Gazzoletto, 4/C –
          26100 Cremona (CR). I Responsabili del Trattamento sono distinti per: personale interno
          nello svolgimento delle proprie attività e mansioni, personale esterno che svolge attività
          di manutenzione dei Sistemi e degli Impianti utilizzati da 4T Insurtech S.r.l.;
        </li>
        <li>
          <span class="font-bold">Diritti dell’interessato artt. da 15 a 22.</span>
          In ogni momento, l’interessato potrà esercitare, ai sensi degli artt. da 15 a 22 del GDPR,
          il diritto di:
          <ul>
            <li>a. Chiedere la conferma dell’esistenza o meno di propri dati personali;</li>
            <li>
              b. Ottenere le indicazioni circa le finalità del trattamento, le categorie dei dati
              personali, i destinatari o le categorie di destinatari a cui i dati personali sono
              stati o saranno comunicati e, quando possibile, il periodo di conservazione;
            </li>
            <li>c. Ottenere la rettifica e la cancellazione dei dati;</li>
            <li>d. Ottenere la limitazione del trattamento;</li>
            <li>
              e. Ottenere la portabilità dei dati, ossia riceverli da un titolare del trattamento,
              in un formato strutturato, di uso comune e leggibile da dispositivo automatico, e
              trasmetterli ad un altro titolare del trattamento senza impedimenti;
            </li>
            <li>f. Opporsi al trattamento in qualsiasi momento;</li>
            <li>
              g. Opporsi ad un processo decisionale automatizzato relativo alle persone fisiche,
              compresa l’eventuale profilazione.
            </li>
          </ul>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacyPolicy',
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>
